import {
  HEADER_BLOCK_DATA,
  BLOGS_BLOCK_DATA,
  RELIVE_MEMORIES_BLOCK_DATA,
  READY_ORDER_BLOCK_DATA,
  WIZARD_STEPS_DIGITIZE_DATA,
  TRUST_EXPERIENCE_TABS_DATA,
  TRUST_EXPERIENCE_TITLE_LIST_DATA,
  ONE_TAB_BLOCK_DATA,
} from '../../shared-blocks';
import { NEW_BIG_IMAGE_WITH_TABS_BLOCK_TAPE_TRANSFER, NEW_BANNER_WITH_IMAGE_BLOCK_DATA } from '../digitize-blocks';

const PHOTO_ALBUMS_PAGE_DATA = [
  { componentName: 'headerBlock', content: HEADER_BLOCK_DATA },
  { componentName: 'newBigImageWithTabsBlock', content: NEW_BIG_IMAGE_WITH_TABS_BLOCK_TAPE_TRANSFER },
  { componentName: 'wizardSteps', content: WIZARD_STEPS_DIGITIZE_DATA },
  { componentName: 'readyOrderBlock', content: READY_ORDER_BLOCK_DATA },
  { componentName: 'oneTabWithImageBlock', content: { ...ONE_TAB_BLOCK_DATA, isDark: true } },
  { componentName: 'newBannerWithImageBlock', content: { withGrayBackground: true, ...NEW_BANNER_WITH_IMAGE_BLOCK_DATA } },
  { componentName: 'trustExperienceBlock', content: { tabs: TRUST_EXPERIENCE_TABS_DATA, titleList: TRUST_EXPERIENCE_TITLE_LIST_DATA } },
  { componentName: 'reliveMemoriesBlock', content: RELIVE_MEMORIES_BLOCK_DATA },
  { componentName: 'blogsBlock', content: BLOGS_BLOCK_DATA },
];

export default PHOTO_ALBUMS_PAGE_DATA;
